module.exports = __webpack_public_path__ + "static/assets/176ab990f78c97e4592a10ddf1cf04dd.png";